export default "__VITE_ASSET__iYA8YaVn__"